import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-input-search',
  standalone: true,
  imports: [FormsModule, TranslateModule],
  templateUrl: './input-search.component.html',
  styleUrl: './input-search.component.scss'
})
export class InputSearchComponent implements OnDestroy {
  @Output() inputSearchValue: EventEmitter<string> = new EventEmitter<string>();

  inputSearch: string = '';
  inputSearchUpdate = new Subject<any>();

  private unsubscribe$: Subject<void> = new Subject()

  constructor() {
    this.inputSearchUpdate.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.unsubscribe$)
    )
      .subscribe(value => {
        this.inputSearchValue.emit(value)
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
